<template>
  <div id="pluginLibraryModal">
    <div class="o-modal">
      <div class="o-modal-content full">
        <div class="o-modal-header">
          <a
            @click="display.modal.pluginLibrary = false"
            class="close clickable"
          ><i class="far fa-times"></i></a>
          <p class="lead">Plugin Library</p>
        </div><!-- /.o-modal-header -->

        <div class="container mt-5" v-if="!hidePlugins">
          <div class="row">
            <div
              v-for="plugin in pluginsDirectory"
              v-bind:key="plugin.id"
              class="col-md-4"
            >
              <div class="card">
                <div class="card-body">
                  <img
                    :src="plugin.logo.url"
                    class="card-img-top bg-secondary p-4"
                    :alt="plugin.logo.alt"
                  />
                  <h5 class="card-title mt-2">{{ plugin.name }}</h5>
                  <p class="card-text">{{ plugin.description }}</p>
                  <button
                    v-if="!farm.plugins || !farm.plugins.includes(plugin.id)"
                    class="btn btn-success"
                    @click="togglePlugin(plugin)"
                  >Activate</button>
                  <button
                    v-else
                    class="btn btn-secondary"
                    @click="togglePlugin(plugin)"
                  >Deactivate</button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div><!-- /.o-modal-content -->
    </div><!-- /.o-modal -->
  </div><!-- /#pluginModal -->
</template>

<script>
import { mapState } from 'vuex'
const fb = require('../../firebaseConfig.js')

export default {
  data () {
    return {
      hidePlugins: false
      // plugins: [
      //   {
      //     id: 'nywgf',
      //     name: 'New York Wine and Grape Foundation',
      //     description: 'Includes the VineBalance Worksheet.',
      //     logo: {
      //       url: 'https://newyorkwines.org/wp-content/uploads/2020/04/NYW-RGB-wt-type-Hor-400x126.png',
      //       alt: 'NY Wines Logo'
      //     }
      //   }
      // ]
    }
  },
  computed: {
    ...mapState([
      'display',
      'farm',
      'pluginsDirectory'
    ])
  },
  methods: {
    togglePlugin (plugin) {
      this.hidePlugins = true
      if (!this.farm.plugins) {
        this.farm.plugins = []
      }
      if (this.farm.plugins.includes(plugin.id)) {
        // Remove the plugin
        this.farm.plugins = this.farm.plugins.filter(item => item !== plugin.id)
      } else {
        // Add the plugin
        this.farm.plugins.push(plugin.id)
        // Send notifications to administrators
        fb.pluginsCollection.doc(plugin.id).get().then(pluginDoc => {
          const pluginData = pluginDoc.data()
          const pluginAdministrators = pluginData.administrators
          pluginAdministrators.forEach(admin => {
            const notificationMessage = 'Every.Farm user, ' + this.$store.state.userProfile.email + ', has activated the ' + plugin.name + ' plugin on ' + this.$store.state.farm.name + '.'
            const notificationUrl = plugin.url
            const notificationSubject = 'Every.Farm Plugin Activation Notification'
            fb.notificationsCollection.add({
              createdOn: new Date(),
              updatedOn: new Date(),
              createdBy: this.$store.state.currentUser.uid,
              farmId: this.$store.state.farm.id,
              subject: notificationSubject,
              message: notificationMessage,
              recipient: admin,
              url: notificationUrl,
              read: false
            })
          })
        })
      }
      setTimeout(() => {
        this.hidePlugins = false
      }, 1)
      fb.farmsCollection.doc(this.farm.id).update({
        updatedOn: new Date(),
        updatedBy: this.$store.state.currentUser.uid,
        plugins: this.farm.plugins
      })
    }
  }
}
</script>
